import React, { useEffect, useState } from 'react';
import { FaCheck, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FiLock } from 'react-icons/fi';
import { useModal } from 'src/hooks/Modal';
import Input from '../components/Forms/Input';
import MaskedInput from '../components/Forms/MaskedInput';

import SelectSimple from '../components/Forms/SelectSimple';
import { useLanguage } from "../hooks/Language"
import { countries } from "../pages/Products/modules/Login/countries";
import api from '../services/api';
import CheckboxInput from './DashboardPages/core/components/Forms/CheckboxInput';
import states from './SignUp/FormContainer/states';

interface IProps {
    changeCountry: Function;
    countryISO: string;
    checkUserValue?: Function;
    cart?: Record<string, any>[];
    key?: string;
    keyName?: string;
}

export const checkDocumentNumber = async (document_number) => {

    const doc = document_number?.toString().replace(/[^0-9]/g, '');
    const valid = await api.get('check-user-document_number', { params: { document_number: doc } });

    return valid?.data?.valid || 'no';

}


const DefaultSignUpFormV4: React.FC<IProps> = ({ key = 'product', keyName = 'product', checkUserValue = (value) => { }, changeCountry, cart }) => {

    const [countryISO, setCountryISO] = useState('BR')
    const [checkUser, setCheckUser] = useState('')
    const [currentDocumentNumber, setCurrentDocumentNumber] = useState('');
    const { translate } = useLanguage();
    const [category, setCategory] = useState('');
    const { addModal } = useModal();

    useEffect(() => {
        setCheckUser('');
        checkUserValue('');
    }, [keyName])
    const verifyAssociate = async (doc, product) => {



        try {

            const validate = await api.get(`/verify-association-api/${product?.hash_link?.toString()}/${product?.project_id}/${doc}`);

            if (validate.status === 200) {
                return true;
            }
            else {
                return false;
            }


        }
        catch (err) {

            addModal({ theme: 'whiteModalMini', title: '', content: <> <p style={{ color: '#333', padding: '10px', fontSize: '14px', textAlign: 'center', width: '100%' }}>{err?.response?.data?.message || err?.response?.data?.error || 'Produto exclusivo para associados'} </p></> })
            return false;
        }



    }


    return <>
        <SelectSimple index={1} mandatory={true} setCallback={(value) => setCountryISO(value)} options={countries} name="country" label={translate('Pais')} />


        {countryISO === 'BR' ? <MaskedInput mandatory={true}
            mask="999.999.999-99"
            name="document_number"
            setCallback={(value) => setCurrentDocumentNumber(value)}
            placeholder={translate('CPF')}
        /> : <Input setCallback={(value) => setCurrentDocumentNumber(value)} mandatory={true} name="document_number"
            placeholder={translate('Nº do documento')} />}

        {!checkUser ? <button type='button' style={{ margin: '5px auto' }} onClick={async () => {


            const product = cart?.[0];

            if (product?.allowed_only === 'Sim') {
                const checkAssociation = await verifyAssociate(currentDocumentNumber, product);
                if (!checkAssociation) {
                    return;
                }
                else {
                    const check = await checkDocumentNumber(currentDocumentNumber);
                    setCheckUser(check);
                    checkUserValue(check);
                }
            }
            else {

                const check = await checkDocumentNumber(currentDocumentNumber);
                setCheckUser(check);
                checkUserValue(check);

            }



        }} className='greenButton2 buttonColored'>Validar</button> : <></>}
        {checkUser === 'no' ? <>
            {countryISO === 'BR' ? <SelectSimple mandatory={true} index={2} options={states} name="state" label="Estado" /> :

                <Input name="state" placeholder={'Província / Região'} />}
            <Input name="city" placeholder={'Município'} />
            <Input mandatory={true} name="name" placeholder={translate('Nome completo')} />
            <Input mandatory={true} name="email" placeholder={translate('E-mail')} />

            {countryISO === 'BR' ? <MaskedInput
                mandatory={true}
                mask="(99) 99999.9999"
                name="phone"
                placeholder={translate('Telefone / Whatsapp')}
            /> : <Input name="phone" mandatory={true}
                placeholder={translate('Telefone')} />}







            <MaskedInput mandatory={true}
                mask="99/99/9999"
                name="extra_1"
                placeholder={translate('Data de nascimento')}
            />
            <SelectSimple index={5} options={[
                { "label": "Selecione", "value": "" },
                { "label": "UFAC - Universidade Federal do Acre", "value": "UFAC - Universidade Federal do Acre" },
                { "label": "AESPI - ASSOCIAÇÃO DE ENSINO SUPERIOR DO PIAUI", "value": "AESPI - ASSOCIAÇÃO DE ENSINO SUPERIOR DO PIAUI" },
                { "label": "ANHANGUERA", "value": "ANHANGUERA" },
                { "label": "CENTRO UNIVERSITÁRIO CESMAC", "value": "CENTRO UNIVERSITÁRIO CESMAC" },
                { "label": "CENTRO UNIVERSITÁRIO ESTÁCIO DA BAHIA", "value": "CENTRO UNIVERSITÁRIO ESTÁCIO DA BAHIA" },
                { "label": "CENTRO UNIVERSITÁRIO ESTÁCIO DO CEARÁ", "value": "CENTRO UNIVERSITÁRIO ESTÁCIO DO CEARÁ" },
                { "label": "CENTRO UNIVERSITÁRIO ÍTALO BRASILEIRO", "value": "CENTRO UNIVERSITÁRIO ÍTALO BRASILEIRO" },
                { "label": "CENTRO UNIVERSITÁRIO MONTE SERRAT", "value": "CENTRO UNIVERSITÁRIO MONTE SERRAT" },
                { "label": "CENTRO UNIVERSITÁRIO PADRE ANCHIETA", "value": "CENTRO UNIVERSITÁRIO PADRE ANCHIETA" },
                { "label": "CENTRO UNIVERSITÁRIO SENAC", "value": "CENTRO UNIVERSITÁRIO SENAC" },
                { "label": "CENTRO UNIVERSITÁRIO UNA", "value": "CENTRO UNIVERSITÁRIO UNA" },
                { "label": "CENTRO UNIVERSITÁRIO UNICAPITAL", "value": "CENTRO UNIVERSITÁRIO UNICAPITAL" },
                { "label": "CENTRO UNIVERSITÁRIO UNIEVANGELICA", "value": "CENTRO UNIVERSITÁRIO UNIEVANGELICA" },
                { "label": "CENTRO UNIVERSITÁRIO UNIFAFIBE", "value": "CENTRO UNIVERSITÁRIO UNIFAFIBE" },
                { "label": "CENTRO UNIVERSITÁRIO UNINOVAFAPI", "value": "CENTRO UNIVERSITÁRIO UNINOVAFAPI" },
                { "label": "CEST - FACULDADE SANTA TEREZINHA", "value": "CEST - FACULDADE SANTA TEREZINHA" },
                { "label": "CESUPA - Centro Universitário do Estado do Pará", "value": "CESUPA - Centro Universitário do Estado do Pará" },
                { "label": "CEUB - CENTRO UNIVERSITÁRIO DE BRASÍLIA", "value": "CEUB - CENTRO UNIVERSITÁRIO DE BRASÍLIA" },
                { "label": "CEUNSP - Centro Universitário Nossa Senhora do Patrocínio", "value": "CEUNSP - Centro Universitário Nossa Senhora do Patrocínio" },
                { "label": "CEUT - CENTRO DE ENSINO UNIFICADO DE TERESINA", "value": "CEUT - CENTRO DE ENSINO UNIFICADO DE TERESINA" },
                { "label": "CLARETIANO CENTRO UNIVERSITÁRIO", "value": "CLARETIANO CENTRO UNIVERSITÁRIO" },
                { "label": "COMPLEXO EDUCACIONAL FMU", "value": "COMPLEXO EDUCACIONAL FMU" },
                { "label": "ESCOLA BAHIANA DE MEDICINA E SAÚDE PÚBLICA", "value": "ESCOLA BAHIANA DE MEDICINA E SAÚDE PÚBLICA" },
                { "label": "ESCOLA SUPERIOR DA AMAZÔNIA", "value": "ESCOLA SUPERIOR DA AMAZÔNIA" },
                { "label": "FACIMP - FACULDADE DE IMPERATRIZ", "value": "FACIMP - FACULDADE DE IMPERATRIZ" },
                { "label": "FACULDADE BARÃO DO RIO BRANCO", "value": "FACULDADE BARÃO DO RIO BRANCO" },
                { "label": "FACULDADE CATÓLICA SALESIANA DO ESPÍRITO SANTO", "value": "FACULDADE CATÓLICA SALESIANA DO ESPÍRITO SANTO" },
                { "label": "FACULDADE CIÊNCIAS MÉDICAS DE MINAS GERAIS", "value": "FACULDADE CIÊNCIAS MÉDICAS DE MINAS GERAIS" },
                { "label": "FACULDADE DA CIDADE DO SALVADOR", "value": "FACULDADE DA CIDADE DO SALVADOR" },
                { "label": "FACULDADE DE CIÊNCIAS E LETRAS DE BRAGANÇA PAULISTA", "value": "FACULDADE DE CIÊNCIAS E LETRAS DE BRAGANÇA PAULISTA" },
                { "label": "Outra", "value": "Outra" }
            ]} name="instituicao" label='Universidade' />

            <SelectSimple index={6} options={[
                { "label": "2032", "value": "2032" },
                { "label": "2031", "value": "2031" },
                { "label": "2030", "value": "2030" },
                { "label": "2029", "value": "2029" },
                { "label": "2028", "value": "2028" },
                { "label": "2027", "value": "2027" },
                { "label": "2026", "value": "2026" },
                { "label": "2025", "value": "2025" },
                { "label": "2024", "value": "2024" },
                { "label": "2023", "value": "2023" },
                { "label": "2022", "value": "2022" },
                { "label": "2021", "value": "2021" },
                { "label": "2020", "value": "2020" },
                { "label": "2019", "value": "2019" },
                { "label": "2018", "value": "2018" },
                { "label": "2017", "value": "2017" },
                { "label": "2016", "value": "2016" },
                { "label": "2015", "value": "2015" },
                { "label": "2014", "value": "2014" },
                { "label": "2013", "value": "2013" },
                { "label": "2012", "value": "2012" },
                { "label": "2011", "value": "2011" },
                { "label": "2010", "value": "2010" },
                { "label": "2009", "value": "2009" },
                { "label": "2008", "value": "2008" },
                { "label": "2007", "value": "2007" },
                { "label": "2006", "value": "2006" },
                { "label": "2005", "value": "2005" },
                { "label": "2004", "value": "2004" },
                { "label": "2003", "value": "2003" },
                { "label": "2002", "value": "2002" },
                { "label": "2001", "value": "2001" },
                { "label": "2000", "value": "2000" },
                { "label": "1999", "value": "1999" },
                { "label": "1998", "value": "1998" },
                { "label": "1997", "value": "1997" },
                { "label": "1996", "value": "1996" },
                { "label": "1995", "value": "1995" },
                { "label": "1994", "value": "1994" },
                { "label": "1993", "value": "1993" },
                { "label": "1992", "value": "1992" },
                { "label": "1991", "value": "1991" },
                { "label": "1990", "value": "1990" },
                { "label": "1989", "value": "1989" },
                { "label": "1988", "value": "1988" },
                { "label": "1987", "value": "1987" },
                { "label": "1986", "value": "1986" },
                { "label": "1985", "value": "1985" },
                { "label": "1984", "value": "1984" },
                { "label": "1983", "value": "1983" },
                { "label": "1982", "value": "1982" },
                { "label": "1981", "value": "1981" },
                { "label": "1980", "value": "1980" },
                { "label": "1979", "value": "1979" },
                { "label": "1978", "value": "1978" },
                { "label": "1977", "value": "1977" },
                { "label": "1976", "value": "1976" },
                { "label": "1975", "value": "1975" },
                { "label": "1974", "value": "1974" },
                { "label": "1973", "value": "1973" },
                { "label": "1972", "value": "1972" },
                { "label": "1971", "value": "1971" },
                { "label": "1970", "value": "1970" },
                { "label": "1969", "value": "1969" },
                { "label": "1968", "value": "1968" },
                { "label": "1967", "value": "1967" },
                { "label": "1966", "value": "1966" },
                { "label": "1965", "value": "1965" },
                { "label": "1964", "value": "1964" },
                { "label": "1963", "value": "1963" },
                { "label": "1962", "value": "1962" },
                { "label": "1961", "value": "1961" },
                { "label": "1960", "value": "1960" }
            ]} name="cpf_familiar" label='Ano de conclusão' />

            <SelectSimple setCallback={(value) => setCategory(value)} label='Categoria' mandatory={true} index={7} name="category_id" options={[
                { label: 'Acadêmicos', value: 'Acadêmicos' },
                { label: 'Médicos', value: 'Médicos' },
                { label: 'Profissionais de saúde', value: 'Profissionais de saúde' },
                { label: 'Residentes', value: 'Residentes' },
                { label: 'Outros', value: 'Outros' },
            ]} />

            {category === 'Médicos' || category === 'Residentes' ? <>


                <Input
                    name="crm"
                    placeholder="CRM"
                />

                <SelectSimple
                    options={states}
                    name="crm_uf"
                    index={8}
                    label={translate('Estado do CRM')}
                />

                <SelectSimple label='Você é prescritor?' mandatory={true} index={9} name="extra_5" options={[
                    { label: 'Sim', value: 'Sim' },
                    { label: 'Não', value: 'Não' },

                ]} />

            </> : <></>}

            <Input name="position"
                placeholder={translate('Especialidade')} />

            <Input name="company" placeholder={translate('Instituição/Empresa')} />
            <Input name="extra_4" placeholder={translate('Telefone da instituição')} />







            <p style={{ fontSize: '14px', textAlign: 'center', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#333' }}> {translate('Crie sua senha de acesso')}</p>



            <Input mandatory={true}
                icon={FiLock}
                name="password"
                type="password"
                placeholder={translate('Cadastre sua senha de acesso')}
            />


            <p style={{ fontSize: '14px', textAlign: 'center', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#333' }}> {translate('Privacidade')}</p>


            <SelectSimple mandatory={true} index={15}

                options={[
                    { label: 'WhatsApp', value: 'WhatsApp' },
                    { label: 'Indicação', value: 'Indicação' },
                    { label: 'Instagram', value: 'Instagram' },
                    { label: 'Facebook', value: 'Facebook' },
                    { label: 'Linkedin', value: 'Linkedin' },
                    { label: 'E-mail marketing', value: 'E-mail marketing' },
                    { label: 'SMS', value: 'SMS' },
                    { label: 'Workplace', value: 'Workplace' },
                    { label: 'Google', value: 'Google' },
                    { label: 'Outros', value: 'Outros' },
                    { label: 'Site Faculdade 4º Congresso UFCSPA', value: 'Site Faculdade 4º Congresso UFCSPA' },
                    { label: 'Sociedades e associações', value: 'Sociedades e associações' },


                ]}
                name="know_about"

                label="Como soube do evento?"
            />

            <CheckboxInput
                style={{ display: 'flex' }}
                name="term"
                unique={true}
                preText={(
                    <>
                        {' '}
                        Li e aceitos os termos e condições deste evento
                        {' '}

                    </>
                )}
                options={[
                    {
                        id: `Sim, eu aceito`,
                        label: 'Sim, eu aceito',
                        value: `Sim, eu aceito`,
                    },

                ]}
            />

            <CheckboxInput
                style={{ display: 'flex' }}
                name="inscricao_1"
                unique={true}
                preText={(
                    <>
                        {' '}
                        Comunicação
                        {' '}

                    </>
                )}
                options={[
                    {
                        id: `Desejo receber comunicados via e-mail`,
                        label: 'Desejo receber comunicados via e-mail',
                        value: `Desejo receber comunicados via e-mail`,
                    },

                ]}
            />


            <CheckboxInput
                style={{ display: 'flex' }}
                name="inscricao_2"
                unique={true}

                options={[
                    {
                        id: `Desejo receber comunicados via sms`,
                        label: 'Desejo receber comunicados via sms',
                        value: `Desejo receber comunicados via sms`,
                    },

                ]}
            />

        </> : <></>}




        {checkUser === 'yes' ? <div className='row'><FaCheck style={{ color: 'green', fontSize: '18px' }} /> <p>Usuário identificado</p></div> : <></>}


    </>
}

export default DefaultSignUpFormV4;